import { useState } from "react";
import { api, ApiError } from "../api/client";
import BrandMark from "../components/BrandMark";

interface Props {
  onLoggedIn: (username: string) => void;
}

// Login page — mirrors the old auth/service.py login card (system-ui, --primary button,
// uniform "Invalid credentials" error). Posts to /api/login, which sets the session
// cookie; on success the app shows the reconciliation UI.
export default function LoginPage({ onLoggedIn }: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api.login(username, password);
      onLoggedIn(r.username);
    } catch (e) {
      // Only a 401 is actually "wrong username/password" — a network failure or a
      // server error mislabelled as bad credentials sends users on a password chase.
      setError(e instanceof ApiError && e.status === 401
        ? "Invalid credentials."
        : "Couldn't sign in — the server may be unavailable. Try again shortly.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center-screen center-screen--bg">
      <form onSubmit={submit} className="card login-card">
        <BrandMark className="login-mark" />
        <h1 className="login-title">Reconciliation — Sign in</h1>
        {error && <div className="badge badge-risk block-badge" role="alert">{error}</div>}
        {/* id/name/htmlFor so the label is programmatically tied to its field and a
            password manager can fill the form. */}
        <label className="field-label field-label--first" htmlFor="login-username">Username</label>
        <input className="input" id="login-username" name="username" autoFocus autoComplete="username"
          value={username} onChange={(e) => setUsername(e.target.value)} />
        <label className="field-label" htmlFor="login-password">Password</label>
        <input className="input" id="login-password" name="password" type="password" autoComplete="current-password"
          value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn btn-primary btn-block" type="submit" disabled={busy || !username || !password}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
